<template>
  <div>
    <topbar
      titulo="Faturamentos"
      :breadcrumbs="breadcrumbs"
      :subtitulo="$t('CONTABIL.RELATORIO_DIARIO_DESCRICAO')"
    />
    <b-row>
      <b-col md="2">
        <input-select-multiple
          ref="anoLetivoId"
          v-model="filtro.ano"
          label="Ano"
          :options="listaAnos"
          required
        />
      </b-col>
      <b-col cols="2">
        <b-btn
          class="botao-acao-filtro mb-3 w-100"
          variant="primary"
          @click="buscarFaturamentos"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-btn>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-table
          :fields="cabecalho"
          :items="listaFaturamentos"
          :empty-text="$t('GERAL.NENHUM_REGISTRO')"
          head-variant="light"
          responsive="sm"
          stacked="md"
          show-empty
          striped
        >
          <template #cell(liberado)="item">
            <b-badge :variant="item.value ? 'success' : 'danger'">{{
              item.value ? 'Sim' : 'Não'
            }}</b-badge>
          </template>
          <template #cell(faturado)="item">
            <b-badge :variant="item.value ? 'success' : 'danger'">{{
              item.value ? 'Sim' : 'Não'
            }}</b-badge>
          </template>
          <template #cell(acoes)="item">
            <b-dropdown variant="outline-default">
              <b-dropdown-item
                v-if="item.item.liberado"
                @click="bloquearFaturamento(item.item?.id)"
              >
                Bloquear
              </b-dropdown-item>
              <b-dropdown-item
                v-else
                @click="liberarFaturamento(item.item?.id)"
              >
                Liberar
              </b-dropdown-item>
              <b-dropdown-item @click="cancelarFaturamento(item.item?.id)">
                Cancelar
              </b-dropdown-item>
              <b-dropdown-item
                @click="realizarFaturamento(item.item?.periodoContabilId)"
              >
                Realizar Faturamento
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="excluirFaturamento(item.item?.id)">
                Excluir
              </b-dropdown-item> -->
            </b-dropdown>
          </template>
        </b-table>
        <paginacao v-model="paginacao" :total="paginacao.total" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import Paginacao from '@/components/paginacao/Paginacao';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import { InputSelectMultiple } from '@/components/inputs';
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import mensagem from '@/common/utils/mensagem';

import FaturamentoService from '@/common/services/contabil/faturamento.service';
import helpers from '@/common/utils/helpers';

export default {
  components: {
    Paginacao,
    Topbar,
    InputSelectMultiple,
  },
  mounted() {
    this.getAnosLetivos();
  },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('CONTABIL.CONTABIL') },
        { titulo: 'Faturamentos' },
      ],
      listaAnos: [],
      filtro: {
        ano: '',
      },
      listaFaturamentos: [],
      cabecalho: [
        {
          key: 'periodoContabilInicio',
          label: 'Data de Início',
          sortable: true,
          formatter: (value) => {
            if (value) return helpers.formatarDataBr(value);
          },
        },
        {
          key: 'periodoContabilFim',
          label: 'Data de Fim',
          sortable: true,
          formatter: (value) => {
            if (value) return helpers.formatarDataBr(value);
          },
        },
        {
          key: 'liberado',
          label: 'Liberado',
        },
        {
          key: 'faturado',
          label: 'Faturado',
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
    };
  },
  methods: {
    excluirFaturamento(id) {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.excluirFaturamento(id)
        .then(() => {
          mensagem.sucesso(
            'Faturamento excluído com sucesso!', ''
          );
          this.buscarFaturamentos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    liberarFaturamento(id) {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.liberarFaturamento(id)
        .then(() => {
          this.$store.dispatch(START_LOADING);
          mensagem.sucesso(
            'Faturamento liberado com sucesso!', ''
          );
          this.buscarFaturamentos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    cancelarFaturamento(id) {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.cancelarFaturamento(id)
        .then(() => {
          mensagem.sucesso(
            'Faturamento cancelado com sucesso!', ''
          );
          this.buscarFaturamentos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    realizarFaturamento(periodoContabilId) {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.realizarFaturamento(periodoContabilId)
        .then(() => {
          mensagem.sucesso(
            'Faturamento realizado com sucesso!', ''
          );
          this.buscarFaturamentos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    bloquearFaturamento(id) {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.bloquearFaturamento(id)
        .then(() => {
          mensagem.sucesso(
            'Faturamento bloqueado com sucesso!', ''
          );
          this.buscarFaturamentos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    buscarFaturamentos() {
      this.$store.dispatch(START_LOADING);
      FaturamentoService.listarFaturamentosPorAno(
        this.filtro.ano.value,
        this.paginacao
      )
        .then(({ data }) => {
          this.listaFaturamentos = data.itens;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar()
        .then(({ data }) => {
          data = data.map((row) => {
            return {
              text: row.ano,
              value: row.ano,
            };
          });

          this.listaAnos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
